import { client, gql } from './Client';

const serviceProvidersQuery = gql`
  query allServiceProvidersInfo {
    allServiceProvidersInfo {
      pkServiceProvider
      organizationName
    }
  }
`;

const serviceProviders = () => client.query({ query: serviceProvidersQuery });

export { serviceProviders };
